export interface ConditionsData {
  temperature: string | null;
  humidity: string | null;
  weather: number | null;
}

export class Conditions {
  private readonly temperature: string | null;
  private readonly humidity: string | null;
  private readonly weather: number | null;

  constructor(data: ConditionsData) {
    this.temperature = data.temperature;
    this.humidity = data.humidity;
    this.weather = data.weather;
  }

  getTemperature(): string | null {
    return this.temperature;
  }

  getHumidity(): string | null {
    return this.humidity;
  }

  getWeather(): number | null {
    return this.weather;
  }
}
